// src/components/Layout/StatsBar.jsx
import React from 'react';
import { useSelector } from 'react-redux';
import { selectTaskCounts, selectFilteredTasks, selectAllTasks } from '../../store/slices/tasksSlice.js';
import { selectFilters } from '../../store/slices/filtersSlice.js';
import { TASK_STATUS_ORDER, TASK_STATUS_LABELS } from '../../constants/task.js';
import { hasActiveFilters } from '../../utils/taskUtils.js';

const STATUS_DOTS = {
  backlog: '#5c5c72',
  in_progress: '#5ba4f5',
  review: '#e8a838',
  done: '#4ade80',
};

export default function StatsBar() {
  const counts = useSelector(selectTaskCounts);
  const totalTasks = useSelector(selectAllTasks).length;
  const filteredTasks = useSelector(selectFilteredTasks);
  const filters = useSelector(selectFilters);
  const active = hasActiveFilters(filters);

  return (
    <div className="stats-bar" aria-label="Board statistics">
      <span className="stat">{totalTasks} total</span>

      {TASK_STATUS_ORDER.map((s) => (
        <span key={s} className="stat" style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
          <span className="stats-sep" aria-hidden="true">·</span>
          <span style={{ color: STATUS_DOTS[s] }} aria-hidden="true">●</span>
          {TASK_STATUS_LABELS[s]}&nbsp;{counts[s]}
        </span>
      ))}

      {active && (
        <span className="stats-filtered" aria-live="polite">
          {filteredTasks.length} matching
        </span>
      )}
    </div>
  );
}
